import React, { useState, useMemo } from 'react';
import { useOrganizations } from '../hooks/useOrganizations';
import LoadingScreen from '../components/common/LoadingScreen';
import CommonPageHeader from '../components/common/CommonPageHeader';
import ProductList from '../components/products/ProductList';
import { BuildingOffice2Icon, CubeIcon, PlusIcon } from '@heroicons/react/24/outline';
import { useLanguage } from 'contexts/LanguageContext';

const Products = () => {
  const { organizations, loading } = useOrganizations();
  const [selectedOrg, setSelectedOrg] = useState<string>('all');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useLanguage();

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <div className="space-y-4">
      <CommonPageHeader
        title={t('products.title')}
        subtitle="Termékek és szolgáltatások kezelése"
        icon={CubeIcon}
        showLastUpdate={false}
      >
        <button
          onClick={() => setIsModalOpen(true)}
          className="inline-flex items-center px-4 py-2 bg-white/20 backdrop-blur-sm text-white rounded-lg hover:bg-white/30 transition-colors"
        >
          <PlusIcon className="w-5 h-5 mr-2" />
          {t('products.new')}
        </button>
      </CommonPageHeader>

      <div className="w-full px-4 sm:px-0">
        <div className="flex flex-wrap sm:flex-nowrap items-center gap-2 overflow-x-auto pb-2">
          <button
            onClick={() => setSelectedOrg('all')}
            className={`flex-none inline-flex items-center px-2.5 sm:px-3 py-1.5 sm:py-2 rounded-lg border text-xs sm:text-sm whitespace-nowrap
              ${selectedOrg === 'all'
                ? 'border-primary-500 bg-primary-500/20 text-primary-400'
                : 'border-gray-600 text-gray-400 hover:border-gray-500'
              }`}
          >
            <BuildingOffice2Icon className="w-3.5 h-3.5 sm:w-4 sm:h-4 mr-1.5 sm:mr-2" />
            {t('products.organizations')}
          </button>
          {organizations.map(org => (
            <button
              key={org.id}
              onClick={() => setSelectedOrg(org.id)}
              className={`flex-none inline-flex items-center px-2.5 sm:px-3 py-1.5 sm:py-2 rounded-lg border text-xs sm:text-sm whitespace-nowrap
                ${selectedOrg === org.id
                  ? 'border-primary-500 bg-primary-500/20 text-primary-400'
                  : 'border-gray-600 text-gray-400 hover:border-gray-500'
                }`}
            >
              <BuildingOffice2Icon className="w-3.5 h-3.5 sm:w-4 sm:h-4 mr-1.5 sm:mr-2" />
              {org.name}
            </button>
          ))}
        </div>
      </div>

      <ProductList selectedOrg={selectedOrg} isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
    </div>
  );
};

export default Products; 